
namespace RioERP.Carts {
    export class CounterProductsColumns {
        static columnsKey = 'Carts.CounterProducts';
    }
}